export default {
    "FETCHED_MESSAGE": "FETCHED_MESSAGE",
    "UPDATED_MESSAGE": "UPDATED_MESSAGE",
    "DELETED_MESSAGE": "DELETED_MESSAGE",
    "CREATED_MESSAGE": "CREATED_MESSAGE",
}